import { overlay, paymentmethod, paymenterror, details, share, payment, paymentresult, paymenticon, accountpayment, terms, paypalpayment, giftwindow, giftpayment, giftcontainer, giftresult, agreement, gifticon, editProfile, editAddress, editPassword, editEmail, editUsername, viewOptionBlock, viewSwitch, viewOptionList, viewDetails, viewFade, viewOwner, viewIcons, viewIconicText, viewBeta, viewOption, viewDesc, viewInfo, viewInfoItem, viewInfoText, taglineSpan, taglineField, viewItems, gamecopies, newsWindow }  from '../animations.overlay';
import { Component, EventEmitter, Query, ViewChild, Output, Input, ViewChildren, ContentChildren, Directive, ElementRef, QueryList, OnInit, trigger, state, animate, style, transition, keyframes, group } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { featuresBox, featureslist }  from '../animations.panels';
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Response, Headers } from '@angular/http';
import { AppComponent } from '../../app.component';
import { UserService } from '../../services/user.service';
import { StoreService } from '../../services/store.service';
import { environment } from '../../environment';
import { CookieService } from 'ngx-cookie';

// Products
import { Item } from '../../models/item';
import { Product } from '../../models/product';
import { News } from '../../models/news';
import { Account } from '../../models/account';
import { Character } from '../../models/character';

declare var $: any

@Component({
  selector: 'user-character',
  templateUrl: './user.character.html',
  providers: [ UserService ],
  animations: [ featuresBox, featureslist, featuresBox, overlay, paymentmethod, paymenterror, details, share, payment, paymentresult, paymenticon, accountpayment, terms, paypalpayment, giftwindow, giftpayment, giftcontainer, giftresult, agreement, gifticon, editProfile, editAddress, editPassword, editEmail, editUsername, viewOptionBlock, viewOptionList, viewDetails, viewSwitch, viewFade, viewOwner, viewIcons, viewIconicText, viewBeta, viewOption, viewDesc, viewInfo, viewInfoItem, viewInfoText, taglineSpan, taglineField, viewItems, gamecopies, newsWindow ]
})
export class CharacterComponent implements OnInit {

	/* Header Tokens */
	public token: any;

	/* Models */
	title: string;
	showNews = true;
	profile: Account;
	subtitle: string;
	showFeatures = true;
	characters: Character;
	x = 0;
	y = 0;

	constructor(private http : Http,
				private user: UserService,
				private store: StoreService,
				private router: Router,
				private route: ActivatedRoute,
				private sanitizer: DomSanitizer) { }
	

	viewUser(user) {
		Promise.resolve(this.user.getProfile(user)).then((profile) => {
			this.profile = profile;
			this.title = profile[0].username;
			this.subtitle = profile[0].subtitle;
		});
	}


	getCharacters() {
		Promise.resolve( this.user.loadUsersCharacters() ).then( (char) => {
			this.characters = char;
		});
	}


	/* On with the show */
	ngOnInit() {
		let username = this.route.snapshot.params['username'];

		this.getCharacters();

		if ( username ) {
			this.viewUser(username);
		}
	}

}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/user/user-character/user.character.component.ts